export const ACTIVE_FILTER = 'Active';
export const CLOSED_FILTER = 'Closed';
export const VIEW_ALL_FILTER = 'view-all';
export const ALL_CONTACTS_FILTER = 'all-contacts';
